import React, { useState } from 'react'
import PropTypes from 'prop-types'
//import { Marker, InfoWindow } from 'react-google-maps'
import { Marker } from 'react-google-maps'

const MarkerWrapper = props => {
  const [isOpen, setIsOpen] = useState(false)
  const { lat, lng, title, icon } = props

  const onToggleOpen = () => {
    setIsOpen(!isOpen)
  }

  return (
    <Marker
      position={{ lat, lng }}
      onClick={() => onToggleOpen()}
      title={title}
      icon={icon}
      data-test="component-maps-markerWrapper"
    />
  )
}

MarkerWrapper.defaultProps = {
  title: null,
  icon: null
}

// Gestion propTypes
MarkerWrapper.propTypes = {
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  title: PropTypes.string,
  icon: PropTypes.element
}

export default MarkerWrapper
